import { Product } from 'schema-dts';
import { JsonLd } from './JsonLD';

function ProductSchema(props: { locale?: string }) {
  const productAr: Product = {
    '@type': 'Product',
    name: 'ناوي ناو Nawy Now: اسكن فورًا وادفع بالتقسيط حتى 10 سنوات - Nawy',
    description:
      'تقدم Nawy Now ناوي ناو حلول تمويل عقاري في مصر لشراء شقق وفلل جاهزة بالتقسيط حتى 10 سنوات. استلام فوري، موافقة تمويل خلال ساعات، وأسعار تنافسية في القاهرة الجديدة، العاصمة الإدارية، والساحل الشمالي.',
    brand: {
      '@type': 'Brand',
      name: 'Nawy'
    },
    url: 'https://www.nawy.com/ar/nawy-now',
    image: 'https://www.nawy.com/assets/images/nawy-now-og.jpg',
    offers: {
      '@type': 'AggregateOffer',
      url: 'https://www.nawy.com/ar/nawy-now',
      priceCurrency: 'EGP',
      lowPrice: '2809841',
      highPrice: '85540465',
      offerCount: 284,
      availability: 'https://schema.org/InStock'
    },
    additionalProperty: [
      {
        '@type': 'PropertyValue',
        name: 'مدة التقسيط',
        value: 'حتى 10 سنوات'
      }
    ]
  };

  const productEn: Product = {
    '@type': 'Product',
    name: 'Nawy Now: Move Now & Pay Later (Over 10 years) - Nawy',
    description:
      'Nawy Now offers mortgage options for ready-to-move properties with up to 10 years installments, instant approval and immediate delivery in New Cairo, New Capital & North Coast.',
    brand: {
      '@type': 'Brand',
      name: 'Nawy'
    },
    url: 'https://www.nawy.com/nawy-now',
    image: 'https://www.nawy.com/assets/images/nawy-now-og.jpg',
    offers: {
      '@type': 'AggregateOffer',
      url: 'https://www.nawy.com/nawy-now',
      priceCurrency: 'EGP',
      lowPrice: '2809841',
      highPrice: '85540465',
      offerCount: 284,
      availability: 'https://schema.org/InStock'
    },
    additionalProperty: [
      {
        '@type': 'PropertyValue',
        name: 'Payment Plans',
        value: 'Over 10 years'
      }
    ]
  };

  return JsonLd<Product>('product-schema', {
    '@context': 'https://schema.org',
    ...(props.locale === 'ar' ? productAr : productEn)
  });
}

export default ProductSchema;
